import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { validateQty } from "@components/config/helpers";
import SecondaryAction from "../Reusables/Buttons/SecondaryAction";

const ProductInputFooter = (props) => {

    const {
        page,
        handleQtyChange,
        addToCart,
        qty = 1,
        product,
        source,
        padProduct,
        sectionID,
        type,
        handleExtra
    } = props;

    const add = () => {
        handleExtra(product, qty[product.product_id]);
        addToCart(product.product_id, product.product_slug, qty[product.product_id], product.bow_color_option, product.pad_color_option, product.color, source, sectionID)
    }
    
    const handleChange = (e) => {
        if(e.target.value > 999){
            e.target.value = 999;
        }

        if(!validateQty(e.target.value)){
            e.target.value = 1;
        }
    }

    return (
        <div className="pb-2">
            <Grid columnSpacing={1} container>
                <Grid xs={6} sm={4} md={6} item>
                    <TextField
                            className="mr-0 w-100"
                        
                            sx={{
                                '& .MuiInputBase-input' : {
                                    padding: '7px'
                                },
                            }}
                            label="Quantity"
                            defaultValue={1}
                            onBlur={(e) => handleQtyChange(e, product.product_id)} //doesnt have input delay
                            // onChange={(e) => handleQtyChange(e, product.product_id)}
                            onChange={handleChange}
                            InputProps={{ inputProps: { min: 1, max: 99, className: 'qty-input'} }}
                            // defaultValue="1"
                            type="number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            disabled={product.poa_price == 'yes' || product?.orderable == 'no' ? true : false}
                        />
                </Grid>
                <Grid item xs={6} sm={8} md={6}>
                    <SecondaryAction
                        size="small"
                        className="cart-add w-100"
                        onClick={add}
                        disabled={product.poa_price == 'yes' || product?.orderable == 'no' ? true : false}
                    >
                        Get Quote
                    </SecondaryAction>
                </Grid>
            </Grid>
        </div>

    )
}

export default ProductInputFooter